<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">職員列表</h1>
      </div>
      <div class="header-right">
        <el-button size="mini" type="warning" @click.native="onAddButton" class="btn-add">新增職員</el-button>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-select
              v-model="listQuery.branchSchoolId"
              placeholder="請選擇分校"
              filterable
              ref="branchSchoolSelect"
              :filter-method="filterBranchSchool"
              clearable
              size="small"
          >
            <el-option
                v-for="(item) in filteredBranchSchools"
                :key="item.id"
                :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                :value="item.id"
                :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
            ></el-option>
          </el-select>
          <el-input
              v-model="listQuery.userNoLike"
              placeholder="職員帳號"
              prefix-icon="el-icon-user"
              size="small"
          ></el-input>
          <el-input
              v-model="listQuery.nameLike"
              placeholder="姓名"
              prefix-icon="el-icon-user"
              size="small"
          ></el-input>

          <el-select
              v-model="listQuery.roleId"
              placeholder="請選擇權限"
              clearable
              size="small"
          >
            <el-option
                v-for="(item, index) in roleList"
                :key="index"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <el-input
              v-model="listQuery.emailLike"
              placeholder="電郵"
              prefix-icon="el-icon-message"
              size="small"
          ></el-input>
          <el-input
              v-model="listQuery.phoneLike"
              placeholder="電話"
              prefix-icon="el-icon-phone"
              size="small"
          ></el-input>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click.native="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無職員數據' : ''"
          >
            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
            <el-table-column prop="userNo" label="職員帳號" align="center" sortable="custom" min-width="120"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center" sortable="custom" min-width="100"></el-table-column>
            <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom" min-width="120">
              <template slot-scope="{ row }">
                <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="roleId" label="權限" align="center" sortable="custom" min-width="100">
              <!-- 改用方法获取角色名称 -->
              <template slot-scope="{ row }">
                <span>{{ getRoleName(row.roleId) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="電郵" align="center" sortable="custom" min-width="180">
              <template slot-scope="{ row }">
                <span v-if="row.email">{{ row.email }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="電話" align="center" sortable="custom" min-width="120">
              <template slot-scope="{ row }">
                <span v-if="row.phone">{{ row.phone }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onEditButton(scope.row.id)" icon="el-icon-edit">編輯</el-button>
                <el-button type="text" size="small" @click="onDeleteButton(scope.row.id)" icon="el-icon-delete">刪除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="user-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="user-name">{{ item.name }}</div>
              <el-tag size="mini" type="info">
                {{ getRoleName(item.roleId) }}
              </el-tag>
            </div>
            <div class="card-body">
              <div class="info-item">
                <span class="info-label">職員帳號：</span>
                <span class="info-value">{{ item.userNo }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">分校：</span>
                <span class="info-value">{{ item.branchSchool?.abbreviation || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">電郵：</span>
                <span class="info-value">{{ item.email || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">電話：</span>
                <span class="info-value">{{ item.phone || '未填寫' }}</span>
              </div>
            </div>
            <div class="card-footer">
              <el-button size="mini" type="warning" @click="onEditButton(item.id)" icon="el-icon-edit">編輯</el-button>
              <el-button size="mini" type="danger" @click="onDeleteButton(item.id)" icon="el-icon-delete">刪除</el-button>
            </div>
          </div>
          <div class="empty-tip" v-if="tableData.length === 0">
            暫無職員數據
          </div>
        </div>
      </div>
    </div>

    <!-- 统一风格分页 -->
    <div class="pagination-wrap">
      <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery._page"
          :limit.sync="listQuery._limit"
          @pagination="getUsers"
      />
    </div>

    <!-- 删除确认弹窗 -->
    <deleteDialog
        titleCh="您確定要刪除此職員嗎？"
        :centerDialogVisible="centerDialogVisible"
        @confirmFunction="confirmFunction"
        @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getUsers, deleteUser } from "@/api/users";
import deleteDialog from "@/components/deleteDialog";

export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      filteredBranchSchools: [],
      roleList: [], // 新增：存储角色列表
      total: 0,
      staffId: null,
      centerDialogVisible: false,
      listQuery: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        roleId: null,
        phoneLike: null,
        branchSchoolId: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    // 初始化角色列表和分校列表
    this.initRoleList();
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
    this.getUsers();
  },
  methods: {
    // 初始化角色列表（过滤掉Parent和Student）
    initRoleList() {
      const allRoles = this.$store.getters.roles || [];
      this.roleList = allRoles.filter(v => v.name !== 'Parent' && v.name !== 'Student');
    },
    // 获取角色名称（替代过滤器）
    getRoleName(roleId) {
      if (!roleId) return "-";
      const role = this.roleList.find(item => item.id === roleId);
      return role?.name || "-";
    },
    // 分校筛选方法
    filterBranchSchool(val) {
      const branchSchools = this.$store.getters.branchSchools || [];
      if (!val) {
        this.filteredBranchSchools = branchSchools;
      } else {
        const searchText = val.toLowerCase().trim();
        this.filteredBranchSchools = branchSchools.filter(item => {
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 排序处理
    handleSortChange(col) {
      this.listQuery.orderBy = col.order ? `${col.prop} ${col.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getUsers();
    },
    // 搜索
    onSearch() {
      this.listQuery._page = 1;
      this.getUsers();
    },
    // 重置
    onReset() {
      Object.keys(this.listQuery).forEach(k => {
        this.listQuery[k] = null;
        if (k === "_page") this.listQuery[k] = 1;
        if (k === "_limit") this.listQuery[k] = 10;
      });
      // 重置分校筛选列表
      this.filteredBranchSchools = this.$store.getters.branchSchools || [];
      this.getUsers();
    },
    // 取消删除
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    // 确认删除
    confirmFunction() {
      this.deleteUser();
    },
    // 删除按钮
    onDeleteButton(id) {
      this.staffId = id;
      this.centerDialogVisible = true;
    },
    // 编辑按钮
    onEditButton(id) {
      this.$router.push(`/staff/${id}/edit`);
    },
    // 新增按钮
    onAddButton() {
      this.$router.push(`/staff/add`);
    },
    // 获取职员列表
    getUsers() {
      const params = {
        ...this.listQuery,
        _page: this.listQuery._page - 1,
      };
      // 清空空值参数
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      getUsers(params).then(v => {
        this.tableData = v.data || [];
        this.total = +v.headers["x-total-count"] || 0;
      }).catch(err => {
        console.error('获取職員列表失敗：', err);
        this.$message.error('獲取職員列表失敗，請稍後重試');
      });
    },
    // 删除职员
    deleteUser() {
      deleteUser(this.staffId)
          .then(() => {
            this.$message.success('刪除職員成功');
            this.getUsers();
          })
          .catch(err => {
            console.error('刪除職員失敗：', err);
            this.$message.error('刪除職員失敗，請稍後重試');
          })
          .finally(() => {
            this.centerDialogVisible = false;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
  }

  .header-right {
    .el-button {
      padding: 8px 16px;
    }
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  //margin-bottom: 16px;
}

/* 统一风格搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      flex: 1;
      min-width: 180px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;
    flex-direction: column;

    .user-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .user-name {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }
      }

      .card-body {
        margin-bottom: 16px;

        .info-item {
          display: flex;
          margin-bottom: 8px;
          line-height: 1.5;

          .info-label {
            color: #6c757d;
            width: 80px;
            flex-shrink: 0;
          }

          .info-value {
            color: #1f2937;
            flex: 1;
            word-break: break-all;
          }
        }
      }

      .card-footer {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
      }
    }

    .empty-tip {
      text-align: center;
      padding: 32px;
      color: #999;
      font-size: 14px;
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 响应式适配（和参考页面完全一致） */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .layout {
    padding: 12px;
  }

  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }
  .table-container .mobile-cards {
    display: flex;
  }
}
</style>